import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0f0f14] text-white pt-16 pb-8 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/57f6aa48d86bbac554c7cfab65cce9bd/40847e940939bf6fdb7f43d0aacd1f0f.png"
              alt="Reader Brothers Printing"
              className="h-20 w-auto object-contain mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
              Two brothers bringing your wildest ideas to life with precision 3D printing. From prototypes to custom art — we build it all.
            </p>
            <p className="mt-4 text-sm font-semibold italic bg-gradient-to-r from-fuchsia-400 via-orange-400 to-cyan-400 bg-clip-text text-transparent">
              "If you can think it, we can build it."
            </p>
            <div className="flex gap-4 mt-6">
              <a href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-gradient-to-br from-fuchsia-500 to-orange-400 hover:opacity-80 transition-opacity cursor-pointer">
                <i className="ri-instagram-line text-white text-base"></i>
              </a>
              <a href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-gradient-to-br from-cyan-500 to-fuchsia-500 hover:opacity-80 transition-opacity cursor-pointer">
                <i className="ri-facebook-fill text-white text-base"></i>
              </a>
              <a href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-gradient-to-br from-orange-400 to-fuchsia-500 hover:opacity-80 transition-opacity cursor-pointer">
                <i className="ri-youtube-fill text-white text-base"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5">
              <a href="#quick-links">Quick Links</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Home', path: '/' },
                { label: 'About Us', path: '/about' },
                { label: 'Contact', path: '/contact' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 text-sm hover:text-fuchsia-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5">
              <a href="#services">Services</a>
            </h4>
            <ul className="space-y-3">
              {['Custom Design', 'Prototyping', 'Art Pieces', 'Functional Parts', 'Miniatures'].map((s) => (
                <li key={s}>
                  <span className="text-gray-400 text-sm">{s}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Watermark */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-xs">
            &copy; {new Date().getFullYear()} Reader Brothers Printing. All rights reserved.
          </p>
          <p className="text-gray-600 text-xs">Made with passion &amp; precision</p>
        </div>
      </div>
    </footer>
  );
}
